export default [
    {
        path: '/proposal/invoice/remark',
        props: true,
        component: () => import('@/views/Proposal/Invoice/Remarks'),
    },
];
